import React from 'react';
import { 
  Stethoscope,
  HeartPulse,
  Brush,
  Calendar,
  XCircle,
  ThermometerSun,
  Utensils,
  Timer,
  CheckCircle2,
  AlertTriangle,
  HelpCircle,
  Shield
} from 'lucide-react';
import './Dto43e2.css';

const Dto43e2: React.FC = () => {
  return (
    <div className="dto43e2">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Dental Implant Care Guide</h1>
          <p>Essential Pre and Post-operative Care for Optimal Results</p>
        </div>
      </div>

      {/* Pre-operative Care */}
      <section className="preop-section container">
        <h2 className="section-title">Before Your Implant Surgery</h2>
        <div className="care-grid">
          <div className="care-card">
            <Stethoscope className="care-icon" />
            <h3>Medical Evaluation</h3>
            <p>
              Comprehensive assessment using 3D CT scans to understand bone structure 
              and plan precise implant placement.
            </p>
          </div>

          <div className="care-card">
            <HeartPulse className="care-icon" />
            <h3>Health Disclosure</h3>
            <p>
              Inform your dentist about any medical conditions including high blood 
              pressure, heart disease, or diabetes.
            </p>
          </div>

          <div className="care-card">
            <Brush className="care-icon" />
            <h3>Oral Hygiene</h3>
            <p>
              Maintain excellent oral hygiene and inform your dentist about smoking, 
              drinking, or betel nut habits.
            </p>
          </div>

          <div className="care-card">
            <Calendar className="care-icon" />
            <h3>Schedule Planning</h3>
            <p>
              Discuss travel plans with your dentist to arrange the most suitable 
              surgery timing.
            </p>
          </div>
        </div>
      </section>

      {/* Post-operative Care */}
      <section className="postop-section">
        <div className="container">
          <h2 className="section-title">After Your Implant Surgery</h2>
          <div className="instructions-grid">
            <div className="instruction-card">
              <XCircle className="instruction-icon" />
              <h3>Activities to Avoid</h3>
              <ul className="instruction-list">
                <li>Vigorous rinsing</li>
                <li>Using straws</li>
                <li>Strenuous exercise</li>
                <li>Opening mouth wide</li>
                <li>Pulling cheeks</li>
              </ul>
            </div>

            <div className="instruction-card">
              <ThermometerSun className="instruction-icon" />
              <h3>Temperature Management</h3>
              <p>
                Apply ice packs to affected area for first 48 hours (15 minutes on, 
                5 minutes off). Switch to warm compresses after day 3 if no fever 
                present.
              </p>
            </div>

            <div className="instruction-card">
              <Utensils className="instruction-icon" />
              <h3>Diet Recommendations</h3>
              <p>
                Stick to soft foods and liquids. Avoid chewing near the surgical 
                site. Gradually return to normal diet as healing progresses.
              </p>
            </div>

            <div className="instruction-card">
              <Timer className="instruction-icon" />
              <h3>Recovery Timeline</h3>
              <p>
                Follow medication schedule precisely. Maintain good rest and avoid 
                smoking, betel nuts, and alcohol during healing.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Maintenance Tips */}
      <section className="maintenance-section container">
        <h2 className="section-title">Long-term Care</h2>
        <div className="maintenance-content">
          <div className="tips-grid">
            <div className="tip-card">
              <CheckCircle2 className="tip-icon" />
              <h3>Daily Cleaning</h3>
              <p>
                Maintain thorough oral hygiene with proper brushing and cleaning 
                between implants.
              </p>
            </div>

            <div className="tip-card">
              <AlertTriangle className="tip-icon" />
              <h3>Watch for Signs</h3>
              <p>
                Monitor for any unusual changes and contact your dentist if you notice 
                discomfort or inflammation.
              </p>
            </div>

            <div className="tip-card">
              <Calendar className="tip-icon" />
              <h3>Regular Check-ups</h3>
              <p>
                Schedule routine dental visits for professional cleaning and implant 
                maintenance.
              </p>
            </div>

            <div className="tip-card">
              <Shield className="tip-icon" />
              <h3>Protection</h3>
              <p>
                Use recommended oral care products and avoid habits that could damage 
                your implants.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">Common Questions</h2>
          <div className="faq-grid">
            <div className="faq-card">
              <HelpCircle className="faq-icon" />
              <h3>Is Bone Grafting Required?</h3>
              <p>
                Not always. The need for bone supplementation varies by individual 
                and requires professional evaluation.
              </p>
            </div>

            <div className="faq-card">
              <HelpCircle className="faq-icon" />
              <h3>Pain Management</h3>
              <p>
                Minimally invasive implants typically cause minimal discomfort, 
                effectively managed with prescribed medication.
              </p>
            </div>

            <div className="faq-card">
              <HelpCircle className="faq-icon" />
              <h3>Recovery Duration</h3>
              <p>
                Most patients return to normal activities within a few days, with 
                complete healing in several weeks.
              </p>
            </div>

            <div className="faq-card">
              <HelpCircle className="faq-icon" />
              <h3>Implant Maintenance</h3>
              <p>
                Regular cleaning, avoiding hard foods, and routine dental check-ups 
                ensure long-term implant success.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43e2;